// tslint:disable-next-line: no-empty
export default () => { };
//# sourceMappingURL=noop.js.map